
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiAssetEsperienzeDialog extends Serenity.EntityDialog<ProdottiAssetEsperienzeRow, any> {
        protected getFormKey() { return ProdottiAssetEsperienzeForm.formKey; }
        protected getIdProperty() { return ProdottiAssetEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiAssetEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiAssetEsperienzeService.baseUrl; }
        protected getDeletePermission() { return ProdottiAssetEsperienzeRow.deletePermission; }
        protected getInsertPermission() { return ProdottiAssetEsperienzeRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiAssetEsperienzeRow.updatePermission; }

        protected form = new ProdottiAssetEsperienzeForm(this.idPrefix);

    }
}